import React from "react";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import { withStyles } from "tss-react/mui";
import vestigingStyle from "../../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import useVestigingRelation from "../../../components/Forms/useVestigingRelation";
import AuthProvider from "../../../auth/AuthProvider";
import CurrencyProvider from "../../../components/Forms/CurrencyProvider";
import VestigingProvider from "../../../components/Forms/VestigingProvider";
import JamezzFormV2 from "../../JamezzForm/JamezzFormV2";
import { formatTitle } from "../../../../utils/formatting";
import { Link } from "react-router";
import parseJSONTryCatched from "../../../Helpers/JSONTryCatched";
import General from "./Tabs/General";

import { connect } from "react-redux";

const endPoint = "core/packagings";

function PackagingForm(props) {
  const { currency, menukaartVestigingId, vestiging, extraFields, onGetModel } = useVestigingRelation({
    vestiging_id: props.vestiging_id,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });

  return (
    <AuthProvider prefix={"packagings"}>
      <CurrencyProvider currency={currency}>
        <VestigingProvider vestiging={vestiging}>
          <JamezzFormV2
            computedPageTitle={function (model) {
              return formatTitle(this.pageTitle, model.name);
            }}
            customFieldSerialization={{
              products: (products) => JSON.stringify(products),
              categories: (categories) => JSON.stringify(categories),
            }}
            endPoint={endPoint}
            excludedKeysInOutput={{ raw_api_data: true }}
            extraFields={extraFields}
            extraFormProps={{ vestiging, vestigingId: vestiging?.id ?? props.vestiging_id, menukaartVestigingId }}
            mode={"onChange"}
            objectsExcludedAsRelation={{
              raw_api_data: true,
              products: true,
              categories: true,
            }}
            onGetModel={onGetModel}
            pageTitle={getTranslation("packaging.form.pageTitle", "Packagings")}
            pageTitleSubject={
              <small>
                <Link to={`/manager/vestigingen/${vestiging?.id}/edit`}>{vestiging?.naam}</Link> - {vestiging?.id}
              </small>
            }
            parseInput={{
              raw_api_data: (response) => (response ? parseJSONTryCatched(response) : null),
            }}
            parseOutput={{ translations: (translations) => (translations ? JSON.stringify(translations) : null) }}
            revalidateMode={"onChange"}
            rootRight={"packagings"}
            tabs={[
              {
                right: "general",
                tabButton: <TranslationWrapper tDefault={"General"} tKey={"packaging.form.tabs.general"} />,
                tabContent: <General />,
              },
              // {
              //   right: "general",
              //   tabButton: <TranslationWrapper tKey={"packaging.form.tabs.products"} tDefault={"Products"} />,
              //   tabContent: <Products />,
              // },
              // {
              //   right: "general",
              //   tabButton: <TranslationWrapper tKey={"packaging.form.tabs.categories"} tDefault={"Categories"} />,
              //   tabContent: <Categories />,
              // },
            ]}
          />
        </VestigingProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(withStyles(PackagingForm, vestigingStyle));
